var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm12: "", md12: "" } },
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.namedConfigurationEntry.ColumnConfigurations,
              "hide-actions": "",
              loading: _vm.isLoadingSubmit,
              pagination: _vm.pagination,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "headers",
                fn: function (props) {
                  return [
                    _c(
                      "tr",
                      _vm._l(props.headers, function (header) {
                        return _c(
                          "th",
                          {
                            key: `col-header${header.value}`,
                            class: [
                              header.sortable ? "column sortable" : "",
                              _vm.pagination.descending ? "desc" : "asc",
                              header.value === _vm.pagination.sortBy
                                ? "active"
                                : "",
                            ],
                            style: { "text-align": header.align || "start" },
                            on: {
                              click: function ($event) {
                                return _vm.changeSort(header)
                              },
                            },
                          },
                          [
                            header.sortable
                              ? _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("arrow_upward"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(header.text || header.value) +
                                "\n            "
                            ),
                            header.value == _vm.dataValidationModeProperty
                              ? _c(
                                  "v-menu",
                                  {
                                    attrs: { "offset-x": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      icon: "",
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("info"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.showValidationModeInfo,
                                      callback: function ($$v) {
                                        _vm.showValidationModeInfo = $$v
                                      },
                                      expression: "showValidationModeInfo",
                                    },
                                  },
                                  [_vm._v(" "), _c("DataValidationModeInfo")],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                },
              },
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c("td", [
                      _c("div", [
                        _vm._v(_vm._s(_vm.getAliasDefaultName(props.item))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          props.item.Implemented != null &&
                          !props.item.Implemented
                            ? _c(
                                "v-chip",
                                {
                                  attrs: {
                                    value: true,
                                    color: "red",
                                    dark: "",
                                    small: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Not\n              Implemented"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("DataValidationModeDropDown", {
                          attrs: {
                            value: props.item.DataValidationMode,
                            editMode: _vm.editMode,
                            canConfigureDataValidationMode:
                              props.item.CanConfigureDataValidationMode,
                            implemented: props.item.Implemented,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.updateColumnDataValidationMode(
                                $event,
                                props.item
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _vm.hasAliases(props.item)
                          ? _vm._l(
                              props.item.NameAliases.filter(
                                (x) => !x.IsDefault
                              ),
                              function (item) {
                                return _c(
                                  "v-chip",
                                  { key: item.Name, attrs: { small: "" } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.Name) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "elevation-1",
                            attrs: { color: "blue", outline: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.openEditColumnModal(props.item.Id)
                              },
                            },
                          },
                          [_vm._v("Settings\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "mt-3 mr-2",
          attrs: { "align-center": "", "justify-end": "" },
        },
        [
          _vm.editMode
            ? [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.saveConfiguration },
                  },
                  [
                    _vm._v("Save\n        "),
                    _c("v-icon", { staticClass: "ml-2", attrs: { dark: "" } }, [
                      _vm._v("save"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "error" },
                    on: { click: _vm.cancelConfiguration },
                  },
                  [
                    _vm._v("Cancel\n        "),
                    _c("v-icon", { staticClass: "ml-2", attrs: { dark: "" } }, [
                      _vm._v("cancel"),
                    ]),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "warning" },
                    on: {
                      click: function ($event) {
                        return _vm.setEditMode(true)
                      },
                    },
                  },
                  [
                    _vm._v("Edit\n        "),
                    _c("v-icon", { staticClass: "ml-2", attrs: { dark: "" } }, [
                      _vm._v("create"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary" },
                    on: { click: _vm.goToConfigList },
                  },
                  [_vm._v("Back\n      ")]
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(_vm.currentComponent, {
        tag: "component",
        attrs: {
          configName: _vm.ConfigurationSettingName,
          columnId: _vm.selectedColumnId,
          editMode: _vm.editMode,
        },
        model: {
          value: _vm.modalValue,
          callback: function ($$v) {
            _vm.modalValue = $$v
          },
          expression: "modalValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }